import { useCallback, useSyncExternalStore } from 'react';

// The ERP's phone breakpoint (Tailwind's md is 768px): below it the shell
// drops the empty bottom band (D6) and the Settings menu carries the company
// and branch switchers.
export const NARROW_QUERY = '(max-width: 767px)';

function list(query: string): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query) : null;
}

// Follows the query live (a window resized, a tablet rotated). Without
// matchMedia (jsdom, old engines) it answers `fallback`.
export function useMediaQuery(query: string, fallback = false): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const mql = list(query);
    if (!mql) return () => undefined;
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange); // Safari before 14
    return () => mql.removeListener(onChange);
  }, [query]);
  return useSyncExternalStore(subscribe, () => list(query)?.matches ?? fallback, () => fallback);
}
